import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { MyQuotationData } from '../../models/quotations/Quotations';

const QUOTES_URL = '/api/v1/quotes';

const useMyQuotationsSWR = () => {
    const fetch = (query): Promise<MyQuotationData[]> => {
        return httpApi
            .get<{ quotes: MyQuotationData[] }>(query)
            .then((res) => {
                return res.getData().quotes;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(QUOTES_URL, fetch, {
        // dedupingInterval: 600000, // 10min
        errorRetryCount: 3,
    });

    return {
        quotes: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useMyQuotationsSWR;
